import React, { useEffect, useRef, useState } from "react";
import * as echarts from 'echarts';
import { post } from '../../services/api'
import { ThreeDots } from "react-loader-spinner";
import img_pista_de_corrida from '../../assets/img/pista-de-corrida.svg'
import img_pista_de_corrida_mobile from '../../assets/img/pista-de-corrida-mobile.svg'
import img_ranking_bg from '../../assets/img/ranking-bg.svg'
import img_ranking_bg_mobile from '../../assets/img/ranking-bg-mobile.svg'
import img_exemplo from '../../assets/img/xicoria.png'

function Ranking({ mesAno, idVendedor, changeMesAno, changeVendedor, cargo, regiao, idVendedorAuxiliar }) {
    const chartRef = useRef(null);

    const [tipoRelatorio, setTipoRelatorio] = useState(3); // Rede como padrão
    const [isFetchingDataRanking, setIsFetchingDataRanking] = useState(false);
    const [isFetchingDataTop10, setIsFetchingDataTop10] = useState(false);
    const [dadosIndiponiveisTop10, setDadosIndisponiveisTop10] = useState(true);
    const [top10, setTop10] = useState([]);
    const [dadosIndiponiveisRanking, setDadosIndisponiveisRanking] = useState(true);
    const [desativaFiltroRegiaoFilial, setDesativaFiltroRegiaoFilial] = useState(false);

    /* Effects Referentes ao TOP 10 */
    useEffect(() => {
        limparDadosTop10();
        getTop10();
    }, [cargo]);

    useEffect(() => {
        limparDadosTop10();
        getTop10();
    }, [changeMesAno]);
    /* Fim dos Effects Referentes ao Ranking Geral */

   
    /* Effects Referentes ao Ranking Geral */
    useEffect(() => {
        getDadosRankingGeral();
    }, [idVendedorAuxiliar]);

    useEffect(() => {
        limparDadosRanking();
        getDadosRankingGeral();
    }, [idVendedor]);

    useEffect(() => {
        limparDadosRanking();
    }, [changeVendedor]);

    useEffect(() => {
        limparDadosRanking();
    }, [changeMesAno]);

    useEffect(() => {
        limparDadosRanking();
        getDadosRankingGeral();
    }, [mesAno]);

    /* Fim dos Effects Referentes ao Ranking Geral */

    function limparDadosTop10() {
        setTop10([]);
        setDadosIndisponiveisTop10(true);
    }

    function limparDadosRanking() {
        setDadosIndisponiveisRanking(true);
        setTipoRelatorio(3);
    }

    const handleTipoRelatorioChange = (value) => {
        setTipoRelatorio(value);
        if (value) {
            getDadosRankingGeral(value);
        }
    };

    async function getDadosRankingGeral(value) {
        try {
            if (idVendedor) {
                const dataAtual = new Date();
                const mesAtual = dataAtual.getMonth() + 1;
                const anoAtual = dataAtual.getFullYear();
                const mesAnoAtualFormatado = mesAtual + '-' + anoAtual;
                const [mes, ano] = mesAno ? mesAno.split('-') : mesAnoAtualFormatado.split('-');
                
                setIsFetchingDataRanking(true);
                setDadosIndisponiveisRanking(false);

                let requisicao;
                let response;
                
                if (cargo === 'GERENTE_REGIONAL') {
                    requisicao = {mes: mes, ano: ano, regiao: regiao};
                    response = await post('vendedores/rankingregional', requisicao); 
                } else {
                    const tipoPontuacao = (cargo === 'GERENTE_LOJA') ? 1 : 2;
                    requisicao = { vendedor: idVendedor, mes: mes, ano: ano, tipoRelatorio: value ? value : 3, tipoPontuacao: tipoPontuacao };
                    response = await post('vendedores/ranking', requisicao);   
                }

                setIsFetchingDataRanking(false);

                if (response && response[0] && response[0] !== undefined) {
                    const rankingSemVendedorSelecionado = response.filter((item) => item.legenda != 'VOCÊ ESTÁ AQUI');

                    let infoVendedorSelecionado = [];
                    infoVendedorSelecionado.pontuacao = response.find((item) => item.legenda == 'VOCÊ ESTÁ AQUI')?.pontuacao;
                    infoVendedorSelecionado.nivel = response.find((item) => item.legenda == 'VOCÊ ESTÁ AQUI')?.nivel;

                    if (infoVendedorSelecionado.pontuacao == undefined) {
                        setDesativaFiltroRegiaoFilial(true);
                    } else {
                        setDesativaFiltroRegiaoFilial(false);
                    }

                    const agrupamentoPorNivel = rankingSemVendedorSelecionado.reduce((acc, item) => {
                        const nivel = item.nivel;
                        const pontuacao = item.pontuacao;
                        acc[nivel] = acc[nivel] || { agrupador: `Nível ${nivel}`, dados: [] };
                        acc[nivel].dados.push(pontuacao);
                        return acc;
                    }, {});

                    const ordenaAgrupamentoNiveisOrdemDecrescente = Object.keys(agrupamentoPorNivel).sort((a, b) => b.localeCompare(a));

                    const dadosAgrupados = ordenaAgrupamentoNiveisOrdemDecrescente.map((nivel) => ({
                        agrupador: agrupamentoPorNivel[nivel].agrupador,
                        dados: agrupamentoPorNivel[nivel].dados,
                    }));

                    gerarRankingGeral(dadosAgrupados, infoVendedorSelecionado);

                } else {
                    setDadosIndisponiveisRanking(true);
                }
            }
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
                setDadosIndisponiveisRanking(true);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
                setDadosIndisponiveisRanking(true);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
                setDadosIndisponiveisRanking(true);
            }
        }
    }

    function gerarRankingGeral(dadosAgrupados, infoVendedorSelecionado) {

        const bolhaVendedorSelecionado = {
            agrupador: 'Sua Posição',
            dados: [infoVendedorSelecionado.pontuacao],
            symbolSize: 25,
            itemStyle: {
                color: 'black',
            },
            nivel: infoVendedorSelecionado.nivel

        };

        dadosAgrupados.push(bolhaVendedorSelecionado);

        const legenda = Array.isArray(dadosAgrupados) ? dadosAgrupados.map((item) => ({
            agrupador: item.agrupador,
        })) : [];

        const options = {
            tooltip: {
                formatter: function (params) {
                    if (params.seriesName === 'Sua Posição') {
                        return `Você está aqui <br/>
                                Pontos: ${params.value[0]} <br/>
                                Nível: ${bolhaVendedorSelecionado.nivel}`;
                    } else {
                        return `Pontos: ${params.value[0]} <br/>
                                ${params.seriesName}`;
                    }
                }
            },
            xAxis: {
                position: 'top',
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: 'rgba(0, 0, 0, 0.5)',
                    },
                },
                axisLabel: {
                    show: true,
                    interval: 'auto',
                },
                splitNumber: 0,
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: 'rgba(0, 0, 0, 0.5)',
                    },
                    onZero: true,
                    emphasis: {
                        lineStyle: {
                            width: 2,
                        },
                    },
                },
            },
            yAxis: {
                axisLabel: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                axisTick: {
                    show: false,
                },
            },
            legend: {
                data: legenda.agrupador,
                itemWidth: 35,
                itemHeight: 12,
                textStyle: {
                    color: '#333',
                },
                icon: 'rect',
                bottom: 5
            },
            series: dadosAgrupados.map(({ agrupador, dados }) => {
                const itemStyle = agrupador === 'Sua Posição' ? bolhaVendedorSelecionado.itemStyle : { color: getCorPorNivel(agrupador) };
                const symbolSize = agrupador === 'Sua Posição' ? bolhaVendedorSelecionado.symbolSize : 10;

                return {
                    type: 'scatter',
                    symbolSize,
                    name: agrupador,
                    data: dados.map(x => [x, Math.random() * 1000, Math.random() * 30]),
                    itemStyle,
                };
            }),
            grid: {
                left: '2%',
                right: '2%',
                bottom: '10%',
                top: '1%',
                containLabel: true,
            },
        };

        var chart = echarts.getInstanceByDom(chartRef.current);

        if (!chart) {
            chart = echarts.init(chartRef.current);
        }

        chart.clear();

        chart.setOption(options);

        window.addEventListener('resize', () => {
            chart.resize();
        });

        return () => {
            chart.dispose();
        };
    }

    async function getTop10() {
        try {
            if (cargo) {
                const dataAtual = new Date();
                const mesAtual = dataAtual.getMonth() + 1;
                const anoAtual = dataAtual.getFullYear();
                const mesAnoAtualFormatado = mesAtual + '-' + anoAtual;

                const [mes, ano] = changeMesAno ? changeMesAno.split('-') : mesAnoAtualFormatado.split('-');
                
                setIsFetchingDataTop10(true);
                setDadosIndisponiveisTop10(false);

                const requisicao = { mes: mes, ano: ano, tipoPontuacao: (cargo === 'GERENTE_LOJA') ? 1 : 2 };
                const response = await post(getRotaTop10(), requisicao);   
                
                setIsFetchingDataTop10(false);

                if (response && response[0] && response[0] !== undefined) {
                    setTop10(response);
                } else {
                    setDadosIndisponiveisTop10(true);
                }
            }
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
                setTop10([]);
                setDadosIndisponiveisTop10(true);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
                setTop10([]);
                setDadosIndisponiveisTop10(true);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
                setTop10([]);
                setDadosIndisponiveisTop10(true);
            }
        }
    }

    function getTituloCargo() {
        if (cargo === 'GERENTE_REGIONAL'){
           return 'Gerentes Regionais';
        }

        if (cargo === 'GERENTE_LOJA'){
            return 'Gerentes de Loja';
        }

        if (cargo === 'VENDEDOR'){
            return 'Vendedores';
        }
    }

    function getRotaTop10() {
        if (cargo === 'GERENTE_REGIONAL'){
           return 'vendedores/top10regional';
        }

        if (cargo === 'GERENTE_LOJA'){
            return 'vendedores/top10';
        }

        if (cargo === 'VENDEDOR'){
            return 'vendedores/top10';
        }
    }

    function getCorPorNivel(nivel) {
        if (nivel === 'Nível E') {
            return 'purple';
        } else if (nivel === 'Nível D') {
            return 'red';
        } else if (nivel === 'Nível C') {
            return '#717308';
        } else if (nivel === 'Nível B') {
            return 'green';
        } else {
            return 'blue';
        }
    }

    function getPosicaoVendedorImagemTop10(posicao) {
        const start = ['3', '6', '9'];
        const end = ['1', '4', '8', '10'];

        if (start.includes(posicao)) {
            return 'start';
        } else if (end.includes(posicao)) {
            return 'end';
        } else {
            return 'center';
        }
    }

    return (
        <div>
            {!dadosIndiponiveisTop10 && (
                <div>
                    <section className="relative">
                        <img src={img_ranking_bg} alt="Imagem de fundo do ranking" className="object-contain w-full hidden" />
                        <img src={img_ranking_bg_mobile} alt="Imagem de fundo do ranking" className="object-contain w-full lg:hidden" />
                        <div className="absolute w-full h-full top-0">
                            <div className="container">
                                <div className="text-center text-blue-c1 font-poppins pt-3 md:pt-8">
                                    <h2 className="font-bold text-base md:text-[26px] md:pb-1">Ranking Top 10 {getTituloCargo()}</h2>
                                    <p className="font-normal text-xs md:text-base">Ordenando por pontuação máxima</p>
                                    {isFetchingDataTop10 && (
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <ThreeDots
                                                height="12"
                                                width="80"
                                                radius="9"
                                                color="#4a8ff7"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={true}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="relative">
                        <img src={img_pista_de_corrida} alt="Pista de corrida" className="object-contain w-full hidden" />
                        <img src={img_pista_de_corrida_mobile} alt="Pista de corrida" className="object-contain w-full lg:hidden" />

                        <div className="absolute w-full h-full top-0 group-overflow">
                            <div className="container h-full max-w-full">
                                <div className="flex lg:grid lg:grid-cols-10 h-full">
                                    {Array.isArray(top10) && top10.map((item, index) => (
                                        <div key={index} className={`self-${getPosicaoVendedorImagemTop10(item.posicao)} ranking-card`}>
                                            <div className="rounded-full border-4 border-white w-16 md:w-20 relative justify-self-center peer cursor-pointer">
                                                <img src={img_exemplo} alt="Imagem do usuário" className="object-cover aspect-square" />
                                                <div className="absolute -top-2 -right-2 bg-green-c6 rounded-full text-white text-sm font-poppins font-normal w-8 h-8 grid">
                                                    <p className="self-center justify-self-center">{item.posicao}º</p>
                                                </div>
                                            </div>

                                            <div className="tooltip tooltip-arrow">
                                                <h6 className="font-bold">{item.nome}</h6>
                                                <p>Nível: {item.nivel}</p>
                                                <p>Pontuação: {item.pontuacao}</p>
                                                <p>{(cargo === 'GERENTE_REGIONAL') ? 'Região: ' : 'Filial: '} {item.localizacao}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            )}

            {!dadosIndiponiveisRanking && (
                <section style={{ background: 'white' }}>
                    <div className="container" >
                        <div>
                            <h4 className="font-poppins font-bold text-3xl text-blue-c1 text-center py-4">Ranking Geral {getTituloCargo()}</h4>
                        </div>
                        <>
                            {(cargo != 'GERENTE_REGIONAL' && desativaFiltroRegiaoFilial == false) && (
                                <div className="flex justify-center mb-4 font-extrabold text-gray-c2 text-sm">
                                    <label className="mr-4 ">
                                        <input
                                            type="radio"
                                            value={3}
                                            checked={tipoRelatorio === 3}
                                            onChange={() => handleTipoRelatorioChange(3)}
                                        />
                                        {'  '}Rede
                                    </label>
                                    <label className="mr-4">
                                        <input
                                            type="radio"
                                            value={1}
                                            checked={tipoRelatorio === 1}
                                            onChange={() => handleTipoRelatorioChange(1)}
                                        />
                                        {'  '}Sua Região
                                    </label>
                                    {cargo == 'VENDEDOR' && (
                                        <label>
                                            <input
                                                type="radio"
                                                value={2}
                                                checked={tipoRelatorio === 2}
                                                onChange={() => handleTipoRelatorioChange(2)}
                                            />
                                            {'  '}Sua Filial
                                        </label>
                                    )}
                                </div>
                            )}

                            {isFetchingDataRanking && (
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <ThreeDots
                                        height="5"
                                        width="80"
                                        radius="9"
                                        color="#ff0000"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClassName=""
                                        visible={true}
                                    />
                                </div>
                            )}
                            <div ref={chartRef} style={{ width: "100%", height: "600px", borderRadius: '10px' }}></div>
                        </>
                    </div>
                </section>
            )}
        </div>
    );
}

export default Ranking